const scopes = {
  deletePayroll: "create:payroll",
  deletePayrollLine: "create:payroll",
  deleteFile: "super:file",
  getConfig: "read:xero",
  getConfigAlerts: "read:xero",
  getConfigHolidays: "read:xero",
  getEmployee: "read:ledger",
  getLedgerPdf: "read:xero",
  getLedgers: "read:ledger",
  getLedgersTotal: "read:ledger",
  getLinePdf: "read:xero",
  getLinesAvailable: "read:xero",
  getLinesTransient: "read:xero",
  getLinesTransientTotal: "read:xero",
  getMeClients: "read:mine",
  getMeConfig: "read:mine",
  getMeConfigAlerts: "read:mine",
  getMeConfigHolidays: "read:mine",
  getMeInfo: "read:mine",
  getMeJob: "read:mine",
  getMeJobs: "read:mine",
  getMeLedger: "read:mine",
  getMeLedgers: "read:mine",
  getMeLedgersTotal: "read:mine",
  getMeLine: "read:mine",
  getMeLines: "read:mine",
  getMeLinesTotal: "read:mine",
  getMeFiles: "read:mine",
  getPayroll: "read:payroll",
  getPayrollExport: "read:payroll:extended",
  getPayrolls: "read:payroll",
  getFiles: "read:file",
  patchLineSkip: "super:ledger",
  patchPayrollAuthorise: "super:payroll",
  patchPayrollLine: "create:payroll",
  patchPayrollUnlock: "super:payroll",
  postConvert: "super:payroll",
  postExportInvoices: "read:xero",
  postImportLedgers: "super:ledger",
  postLedgers: "create:ledger",
  postLinesProcess: "create:ledger",
  postMeRequestCurrency: "request:xero",
  postMeRequestInvoice: "request:xero",
  postPayrollLines: "create:payroll",
  postPayrollRevise: "create:payroll",
  postPayrolls: "create:payroll",
  postImportFiles: "create:file", //TODO: Remove here
};

export default scopes;
